import { Box, Icon, Select, Text, TextFieldAppearance, TextFieldSize } from '@bechtel/gds';
import { InventoryStatus } from '@bechtel/ht-types';
import { IconName } from '@fortawesome/fontawesome-svg-core';
import { find } from 'lodash';
import { useState } from 'react';
import { OptionStyled, ToolStatusIconStyled, ToolStatusStyled, ToolStatusTextStyled } from './styled';

interface ToolStatusProps {
  selectedStatus: InventoryStatus;
  setSelectedStatus: Function;
  disabled: boolean;
}

export const ToolStatus: React.FC<ToolStatusProps> = ({ selectedStatus, setSelectedStatus, disabled }) => {
  const [loading] = useState(false);
  const SelectedOptionItem = ({ item }: any) => {
    return (
      <Box>
        <Text color="grey.500" size="400">
          {item === InventoryStatus.WRITEOFF ? 'WRITE-OFF' : item}
        </Text>
      </Box>
    );
  };

  const OptionItem = ({ item }: any) => {
    const detail = getIconName(item ?? InventoryStatus.GOOD);
    let iconName: IconName = detail[0];
    return (
      <OptionStyled>
        <Box p={{ sm: '400' }}>
          <Icon fillColor={detail[1]} iconStyle="regular" icon={iconName} />
        </Box>
        <Text color="grey.500" size="400">
          {item === InventoryStatus.WRITEOFF ? 'WRITE-OFF' : item}
        </Text>
      </OptionStyled>
    );
  };
  const statusList = Object.values(InventoryStatus);
  const selectedCheckedInStatus = find(statusList, (item: any) => item === selectedStatus);

  const getIconName = (status: InventoryStatus) => {
    let iconName: IconName = 'check';
    let fillColor: string = 'green.500';
    switch (status) {
      case InventoryStatus.REPAIR:
        iconName = 'screwdriver-wrench';
        fillColor = 'orange.600';
        break;
      case InventoryStatus.WRITEOFF:
        iconName = 'circle-exclamation';
        fillColor = 'red.600';
        break;
    }
    return [iconName, fillColor];
  };
  const detail = getIconName(selectedStatus ?? InventoryStatus.GOOD);
  const iconName: IconName = detail[0];
  return (
    <ToolStatusStyled status={selectedStatus ?? InventoryStatus.GOOD} disabled={disabled} flexShrink={{ sm: '0' }}>
      <ToolStatusIconStyled disabled={disabled} status={selectedStatus ?? InventoryStatus.GOOD}>
        <Icon iconStyle="regular" fillColor="white" icon={iconName} />
      </ToolStatusIconStyled>
      <ToolStatusTextStyled status={selectedStatus ?? InventoryStatus.GOOD}>
        <Select
          disabled={disabled}
          size={TextFieldSize.SMALL}
          appearance={TextFieldAppearance.NORMAL}
          items={statusList}
          itemComponent={OptionItem}
          selectedComponent={SelectedOptionItem}
          initialSelectedItem={selectedCheckedInStatus ? selectedCheckedInStatus : InventoryStatus.GOOD}
          loading={loading}
          onSelectedItemChange={({ selectedItem }) => {
            setSelectedStatus(selectedItem);
          }}
        />
      </ToolStatusTextStyled>
    </ToolStatusStyled>
  );
};
